import { FC } from 'react';
import { Chip, Typography } from '@mui/material';
import { InfoIcon } from '~/icons';
import { disabledStudioCreationChipStyles } from './styles';

interface CreationDisabledChipProps {
  description: string;
  title: string;
}

const CreationDisabledChip: FC<CreationDisabledChipProps> = ({ title, description }) => (
  <Chip
    icon={<InfoIcon style={{ width: 20, height: 20 }} />}
    sx={disabledStudioCreationChipStyles}
    label={
      <Typography variant="buttonTextLarge" color="textBlackReduced.main" whiteSpace="wrap" textOverflow="unset">
        <Typography variant="buttonTextLarge" color="textBlackStd.main">
          {title}
        </Typography>
        {description}
      </Typography>
    }
  />
);

export default CreationDisabledChip;
